import React from 'react';
import './QuoteDocument.css';

/**
 * The customer's quote, on screen — same layout as the PDF (QuotePdf.jsx). `model` comes from quoteModel().
 * Summary hides the Qty / Rate / Amount columns; Detailed shows them.
 */
const QuoteDocument = ({ model }) => {
  const detailed = model.format === 'detailed';
  const { customer, company, totals } = model;
  return (
    <div className={`qdoc ${detailed ? 'detailed' : 'summary'}`}>
      <div className="qdoc-top">
        <img src="/cie-logo-navy-tight.png" alt={company.name} />
        <div className="qdoc-meta">
          <div className="qdoc-doc">QUOTE</div>
          {model.number && <div>Quote # <b>{model.number}</b></div>}
          <div>Date <b>{model.date}</b></div>
          <div>Valid until <b>{model.validUntil}</b></div>
        </div>
      </div>

      <div className="qdoc-title">
        <div className="qdoc-eyebrow">Attic insulation proposal</div>
        <h1>{model.title}</h1>
        {customer.address && <p>Prepared for your home at {customer.address}</p>}
      </div>

      <div className="qdoc-parties">
        <div className="qdoc-party">
          <div className="qdoc-lbl">Prepared for</div>
          <div className="qdoc-name">{customer.name || 'Customer'}</div>
          {customer.address && <div>{customer.address}</div>}
          {[customer.email, customer.phone].filter(Boolean).join(' · ')}
        </div>
        <div className="qdoc-party">
          <div className="qdoc-lbl">Prepared by</div>
          <div className="qdoc-name">{company.name}</div>
          <div>{company.street}, {company.cityline}</div>
          <div>{company.phone} · {company.email}</div>
          {model.agent && <div>Your advisor: {model.agent}</div>}
        </div>
      </div>

      <h2 className="qdoc-sec">Scope of work</h2>
      <table className="qdoc-table">
        <thead>
          <tr>
            <th>Service</th>
            {detailed && <th className="num">Qty</th>}
            {detailed && <th className="num">Rate</th>}
            {detailed && <th className="num">Amount</th>}
          </tr>
        </thead>
        <tbody>
          {model.groups.map((g) => (
            <React.Fragment key={g.category}>
              <tr className="qdoc-cat"><td colSpan={detailed ? 4 : 1}>{g.category}</td></tr>
              {g.lines.map((l, i) => (
                <tr key={i} className="qdoc-item">
                  <td>
                    <div className="qdoc-item-name">{l.name}</div>
                    {l.description && <div className="qdoc-item-desc">{l.description}</div>}
                  </td>
                  {detailed && <td className="num">{l.qty}</td>}
                  {detailed && <td className="num">{l.rate}</td>}
                  {detailed && <td className={`num amt${l.included ? ' incl' : ''}`}>{l.amount}</td>}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      <div className="qdoc-totals">
        <div><span>Subtotal</span><span>{totals.subtotal}</span></div>
        {totals.discount && <div className="disc"><span>{totals.discountName}</span><span>{totals.discount}</span></div>}
        <div><span>HST (13%)</span><span>{totals.hst}</span></div>
        <div className="grand"><span>Total</span><span>{totals.total}</span></div>
      </div>

      {model.terms && (
        <div className="qdoc-terms">
          <div className="qdoc-lbl">Quote terms</div>
          <div>{model.terms}</div>
        </div>
      )}

      <div className="qdoc-foot">
        <b>{company.name}</b>
        <div>{company.street}, {company.cityline} · {company.phone} · {company.email}</div>
        {model.hstNumber && <div>HST # {model.hstNumber}</div>}
      </div>
    </div>
  );
};

export default QuoteDocument;
